import script from "./ManagementActivos.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementActivos.vue?vue&type=script&setup=true&lang=js"

import "./ManagementActivos.vue?vue&type=style&index=0&id=c3b14fbc&scoped=true&lang=css"
import "./ManagementActivos.vue?vue&type=style&index=1&id=c3b14fbc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3b14fbc"]])

export default __exports__